// ** Third Party Imports
import styled, { css } from 'styled-components'

interface ButtonPublicProps {
	size?: 'normal' | 'small'
	variant: 'primary' | 'secondary' | 'tertiary'
	disabled?: boolean
	$fullWidth?: boolean
}
const buttonStyles = css<ButtonPublicProps>`
	font-family: 'Lemon/Milk';
	font-weight: 400;
	font-style: normal;
	letter-spacing: 0%;
	border: none;
	outline: none;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	text-decoration: none;
	justify-content: center;
	font-size: 1rem;
	border-radius: 4px;
	gap: 10px;
	padding: 0.7rem 1.55rem;
	box-shadow: ${({ variant }) =>
		variant !== 'tertiary' ? '0px 5px 11px 0px #0000001a' : 'none'}};

	${({ $fullWidth }) => $fullWidth && `width: 100%;`}

	${({ variant, theme }) => {
		const colors = {
			primary: {
				background: theme.pallette.public.main,
				color: '#fff'
			},
			secondary: {
				background: theme.pallette.public.secondary,
				color: '#fff'
			},
			tertiary: {
				background: theme.pallette.public.gray,
				color: theme.pallette.public.main
			}
		}

		const selected = colors[variant]

		return css`
			background: ${selected.background};
			color: ${selected.color};
		`
	}}

  ${({ disabled, theme }) =>
		disabled &&
		css`
			background: ${theme.pallette.primary.disabled};
			color: #fff;
			pointer-events: none;
		`}
`

export const StyledButtonPublic = styled.button<ButtonPublicProps>`
	${buttonStyles}
`
